// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2HoXg","top":"styles_top__15m74","left":"styles_left__dFNn6","description":"styles_description__2o5uT"};